import type * as React from 'react';

import { OrganizationFeature, type Organization } from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';

import { useGetUpgradeAction } from '../../state';

/**
 * Footer of the search modal presenting the GitBook AI feature.
 */
export function AppSearchAIFooter(props: {
    organization: Organization;
}): React.ReactElement | null {
    const { organization } = props;

    const upgrade = useGetUpgradeAction({
        organization,
        featureKey: OrganizationFeature.AiLens,
    });

    if (!upgrade) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 text-neutral-low">
            <Icon.SearchOrAsk size={16} />
            <span>
                Find an answer using <strong>GitBook AI</strong>
            </span>
            <div className="ml-2">
                <Button size="small" {...upgrade} />
            </div>
        </div>
    );
}
